import React from 'react'

export const PaymentsDropdownContainer = (props: {
  children:
    | boolean
    | React.ReactChild
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined
}) =>
  React.createElement(
    'div',
    {
      style: { display: 'block', width: '15rem', marginTop: '1.5rem' },
      ...props,
    },
    props.children,
  )
